import { Checkbox, Group, Tooltip } from '@mantine/core';

interface HrTermVariant {
  variantId: number;
  name: string;
  description: string;
}

interface HrTermVariantCheckboxesProps {
  variants: HrTermVariant[];
  checkedVariantIds: number[];
  disabled?: boolean;
  onChange: (variantIds: number[]) => void;
}

/** Renders all variants of one term type inline, with explanatory hover text. */
export default function HrTermVariantCheckboxes({
  variants,
  checkedVariantIds,
  disabled = false,
  onChange,
}: HrTermVariantCheckboxesProps) {
  if (variants.length === 0) return null;

  return (
    <Group spacing="xl" align="center">
      {variants.map((variant) => (
        <Checkbox
          key={variant.variantId}
          checked={checkedVariantIds.includes(variant.variantId)}
          disabled={disabled}
          label={
            variant.description ? (
              <Tooltip label={variant.description} withArrow>
                <span>{variant.name}</span>
              </Tooltip>
            ) : (
              <span>{variant.name}</span>
            )
          }
          onChange={(event) =>
            onChange(
              event.currentTarget.checked
                ? [...checkedVariantIds, variant.variantId]
                : checkedVariantIds.filter((variantId) => variantId !== variant.variantId)
            )
          }
        />
      ))}
    </Group>
  );
}
